import { SheetModal } from '../../../app/components/SheetModal/SheetModal';
import { SheetModalHeader } from '../../../app/components/SheetModal/SheetModalHeader';
import { useIsMobile } from '../../../app/hooks/useIsMobile';
import { Modal } from '../../../app/components/Modal/Modal';
import SessionIcon from '../../../app/assets/icons/session.svg?react';
import { useThemeContext } from '../../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../Translations/providers/TranslationsContextProvider';
import {MediaStatus, useMediaAvailability} from "../../Media/components/useMediaAvailability.ts";

export function CapabilitiesKoModal({ onClose }: {onClose: () => void;}) {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();
	const isMobile = useIsMobile();
	const { cameraStatus, micStatus } = useMediaAvailability();

	const getMessage = () => {
		const statuses = new Set([cameraStatus, micStatus]);

		const messages: Record<MediaStatus, string> = {
			"in-use": t("errors.devices_in_use_description"),
			denied: t("errors.devices_denied"),
			"not-found": t("errors.devices_not_found"),
			error: t("errors.devices_error"),
			idle: t("waiting_room.capabilities_ko.message"),
			available: t("waiting_room.capabilities_ko.message"),
		};

		for (const status of ["in-use", "denied", "not-found", "error"] as const) {
			if (statuses.has(status)) return messages[status];
		}

		return t("waiting_room.capabilities_ko.message");
	};

	return (
		isMobile ? (
			<SheetModal
				data-testid="waiting-room_capabilities-ko"
				isOpen
				onClose={onClose}
				header={
					<SheetModalHeader
						prepend={
							<SessionIcon
								fill={theme.colors.brand.primary[300]}
								width={25}
								height={25}
							/>
						}
						title={t('waiting_room.capabilities_ko.title')}
					/>
				}
			>
				<p>{t('waiting_room.capabilities_ko.message')}</p>
			</SheetModal>
		) : (
			<Modal
				data-testid="waiting-room_capabilities-ko"
				show
				title={t('waiting_room.capabilities_ko.title')}
				$fitToChildren
				onClose={onClose}
				prepend={
					<SessionIcon
						fill={theme.colors.brand.primary[300]}
						width={25}
						height={25}
					/>
				}
			>
				<p>{getMessage()}</p>
			</Modal>
		)
	);
}
